import { render } from "./ColumnChooser.vue?vue&type=template&id=39d9cbd1&scoped=true"
import script from "./ColumnChooser.vue?vue&type=script&lang=js"
export * from "./ColumnChooser.vue?vue&type=script&lang=js"

import "./ColumnChooser.vue?vue&type=style&index=0&id=39d9cbd1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d9cbd1"]])

export default __exports__